//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
// Derived from code from the Material UI project under the following license:
//
// The MIT License (MIT)
//
// Copyright (c) 2014 Call-Em-All
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
//
import React from "react";
import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Slide from "@material-ui/core/Slide";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import { withStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import SessionInfoFooter from "../SessionInfoFooter";
var styles = function styles(theme) {
  return {
    menuButton: {
      marginLeft: -theme.spacing(1)
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1
    },
    bottomAppBar: {
      zIndex: theme.zIndex.drawer + 1,
      top: "auto",
      bottom: 0,
      backgroundColor: "white"
    },
    grow: {
      flexGrow: 1
    }
  };
};
function HideOnScroll(_ref) {
  var children = _ref.children;
  var trigger = useScrollTrigger();
  return /*#__PURE__*/React.createElement(Slide, {
    appear: false,
    direction: "down",
    in: !trigger
  }, children);
}
function Header(_ref2) {
  var classes = _ref2.classes,
    onDrawerToggle = _ref2.onDrawerToggle,
    topButtons = _ref2.topButtons,
    bottomButtons = _ref2.bottomButtons,
    hideListIcon = _ref2.hideListIcon;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HideOnScroll, null, /*#__PURE__*/React.createElement(AppBar, {
    key: "header",
    position: "fixed",
    className: classes.appBar,
    color: "primary",
    elevation: 2
  }, /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 1,
    alignItems: "center"
  }, !hideListIcon && /*#__PURE__*/React.createElement(Hidden, {
    smUp: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(IconButton, {
    color: "inherit",
    "aria-label": "open drawer",
    onClick: onDrawerToggle,
    className: classes.menuButton
  }, /*#__PURE__*/React.createElement(MenuIcon, null)))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement("img", {
    src: "static/images/headerLogo.png",
    title: "Logo",
    alt: "Logo",
    height: "30px"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: true
  }), topButtons && topButtons.map(function (button, index) {
    return /*#__PURE__*/React.createElement(Grid, {
      key: index,
      item: true
    }, button);
  }))))), bottomButtons && /*#__PURE__*/React.createElement(AppBar, {
    key: "footer",
    position: "fixed",
    className: classes.bottomAppBar,
    elevation: 0
  }, /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(Hidden, {
    smDown: true
  }, /*#__PURE__*/React.createElement(SessionInfoFooter, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.grow
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row"
  }, bottomButtons.map(function (button, index) {
    return /*#__PURE__*/React.createElement(Box, {
      key: index,
      p: 0.5
    }, button);
  })))));
}
export default withStyles(styles)(Header);